import { object, string, number, array ,date, InferType } from 'yup';
import { AccesoriesModel } from '../../../../../models/ItemModel';

const ItemsSchema = object({
    qty: number().min(1, "Must be more than 1")
})

export default ItemsSchema